export interface ICountry {
  id: number,
  iso2: string,
  iso3: string,
  masks: string[],
  name: string,
}

export interface IDefaultCountries {
  [key: string]: ICountry
}

export const defaultCountriesPreparation = (arr: Array<any>): IDefaultCountries => arr.reduce((acc, cur) => {
  acc[cur.iso2] = cur;
  return acc;
}, {});


export const defaultCountries = (obj: IDefaultCountries) => {
  let countries: Array<ICountry> = [];

  // create country arr
  for(let key in obj) {
    let item: ICountry = <ICountry> { ...obj[key] };
    countries.push(item);
  }

  // sort country arr
  sortArr(countries, 'name');

  return countries
}

export const sortArr = (arr:Array<any>, key:string) => {
  return arr.sort((a, b) => a[key] > b[key] ? 1 : -1);
}

export const masksPreparation = (masksArr: Array<any>): Array<any> | string => {
  const arr = Array.from(masksArr);
  let masks:string[] = arr.sort((a:string, b:string) => a.length - b.length);
  let updatedMasksArr: Array<any> = masks.map((item: any) => item.replace(/9/g, "\\9"), []);

  return updatedMasksArr.length ? updatedMasksArr : "+9{1,14}";
};

export const defaultCountryCodeByBrand = (brand: string) => {
  const defaultCode = { code: 'UA' };

  switch (brand) {
    case 'afft':
      return defaultCode;
    case 'bat':
      return defaultCode;
    case 'grp':
      return defaultCode;
    case 'pkmp':
      return defaultCode;
    case 'lxa':
      return { code: 'TR' };
    case 'btwnp':
      return { code: 'CL' };
    case 'pmaff':
      return defaultCode;
    case 'btfp':
      return { code: 'CL' };
    case 'frgp':
      return { code: 'TR' };
    case 'msla':
      return { code: 'TR' };
    case 'odag':
      return { code: 'GR' };
    case 'fbta':
      return { code: 'TR' };
    case 'lxbp':
      return { code: 'KE' };
    case 'vph':
      return defaultCode;
    case 'mrkp':
      return { code: 'AR' };
    case 'nwnp':
      return { code: 'TR' };
    case 'btza':
      return { code: 'TR' };
    case 'gnbt':
      return { code: 'TR' };
    case 'khlp':
      return { code: 'KZ' };
    case 'alfwn':
      return { code: 'LB' };
    case 'ownbt':
      return { code: 'LB' };
    case 'lirv':
      return { code: 'LB' };
    case 'koor':
      return { code: 'LB' };
	  case 'lrma':
		  return { code: 'LB' };
	  case 'slpkng':
		  return { code: 'CA' };
		case 'bsba':
		  return { code: 'TN' };
		case 'rooag':
		  return { code: 'TN' };
		case 'aypr':
		  return { code: 'TR' };
		case 'turx':
		  return { code: 'TR' };
	  case 'orbt':
		  return { code: 'TN' };
	  case 'mngd':
		  return { code: 'AR' };
	  case 'crpb':
		  return { code: 'TN' };
	  case 'nvdp':
		  return { code: 'CA' };
	  case 'betb':
		  return { code: 'TR' };
		case 'ldrbt':
		  return { code: 'TR' };
		case 'mpma':
		  return { code: 'MY' };
		case 'ripa':
		  return { code: 'TR' };
		case 'betx':
		  return { code: 'TR' };
		case 'bnfp':
		  return { code: 'TR' };
		case 'cupa':
		  return { code: 'AR' };
		case 'cmdf':
		  return { code: 'TR' };
		case 'rupa':
		  return { code: 'TR' };
		case 'stkd':
		  return { code: 'CA' };
		case 'usta':
		  return { code: 'TR' };
    default:
      return defaultCode;
  }
}
